import React, {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Popup} from '@tickchak/react-share/app';
import {TShow} from '../../../../hooks/useShow';
import * as css from './SheetShell.css';

interface SheetShellProps {
    show: TShow;
    title: string;
    children: ReactNode;
    'data-cy'?: string;
}

function SheetShell({show, title, children, 'data-cy': dataCy}: SheetShellProps): React.ReactElement {
    const {t} = useTranslation('eTicket');

    return (
        <Popup show={show} data-cy={dataCy}>
            <css.panel>
                <css.handle aria-hidden />
                <css.title>{title}</css.title>
                {children}
                <css.footer>
                    <Button variant="primary" size="primary" onClick={show.close} data-cy={`${dataCy}-close`}>
                        {t('close')}
                    </Button>
                </css.footer>
            </css.panel>
        </Popup>
    );
}

export default SheetShell;
